import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EvolutionAiAnalysis } from 'src/app/shared/models/evolutionAiAnalysis';

@Component({
    selector: 'app-evolution-ai-detail',
    templateUrl: './evolution-ai-detail.component.html',
    styleUrls: ['./evolution-ai-detail.component.scss'],
})
export class EvolutionAiDetailComponent {
    @Input() analysis: EvolutionAiAnalysis;
    @Output() rate = new EventEmitter<void>();
}
